import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/faqs";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <SectionHeading
          kicker="常见问题"
          title="追更常见问题"
          desc="关于完结情况、更新进度与追更方式的高频疑问，一次讲清。"
        />
        <div className="mt-10 space-y-3">
          {faqs.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="text-sm font-semibold text-foreground-950 md:text-base">
                    {item.q}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                    }`}
                  >
                    <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`} />
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="border-t border-background-100 pt-4 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}